import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import SinglePass from "./SinglePass";
import "../../../style/block.scss";
import "../../../style/feature.scss";
import { useSelector } from "react-redux";
import { State } from "../../store";
import "./Passes.scss";
import EAPageHeader from "../shared/EAPageHeader";
import EASkeletonLoader from "../shared/EASkeletonLoader";
import EAPageMessage from "../shared/EAPageMessage";
import usePasses from "./hooks/usePasses";
import getId from "../../../utils/getId";

const PassesPage: React.FC = () => {
  const { passes, loading, selectedDate, setDateBetween } = usePasses();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedPassId, setSelectedPassId] = useState<string | null>(null);
  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  useEffect(() => {
    const passId = searchParams.get("passId");
    if (passId && passes.length > 0) {
      const passExists = passes.some((pass) => getId(pass) === passId);
      if (passExists) {
        setSelectedPassId(passId);
      } else {
        handleModalClose();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, passes]);

  const handleModalClose = () => {
    const currentParams = Object.fromEntries(searchParams.entries());
    const { passId, ...restParams } = currentParams;
    setSearchParams(restParams);
    setSelectedPassId(null);
  };

  const handlePassSelect = (passId: string) => {
    const currentParams = Object.fromEntries(searchParams.entries());
    setSearchParams({
      ...currentParams,
      passId,
    });
    setSelectedPassId(passId);
  };

  return (
    <>
      <EAPageHeader componentId="PassSale" />
      <EAPageMessage message={saleConfiguration.message_passes} />

      <div className="passes-list">
        {loading ? (
          <EASkeletonLoader width="100%" height="400px" />
        ) : (
          <>
            {passes.map((item) => (
              <SinglePass
                key={item.objectId}
                item={item}
                isSelected={getId(item) === selectedPassId}
                onModalClose={handleModalClose}
                onPassSelect={() => handlePassSelect(getId(item))}
                selectedDate={selectedDate}
                setDateBetween={setDateBetween}
              />
            ))}
          </>
        )}
      </div>
    </>
  );
};

export default PassesPage;
